import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-16">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50" onClick={onClose} data-id="element-17" />
          <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 40,
        scale: 0.97
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="fixed inset-4 md:inset-auto md:top-[5%] md:left-1/2 md:-translate-x-1/2 md:w-full md:max-w-2xl md:max-h-[90vh] bg-[#0F1419] border border-[#D4A843]/20 rounded-2xl z-50 flex flex-col shadow-2xl" data-id="element-18">
            <div className="flex items-center justify-between p-6 border-b border-[#1A1F2E]" data-id="element-19">
              <h2 className="text-xl font-serif font-bold text-[#F5F0E8]" data-id="element-20">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-lg hover:bg-[#1A1F2E] transition-colors text-[#8B8578] hover:text-[#F5F0E8]" data-id="element-21">
                <X className="w-5 h-5" data-id="element-22" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto flex-1 text-[#8B8578] text-sm leading-relaxed space-y-4" data-id="element-23">
              {children}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}
export function Footer() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <>
      <footer className="bg-[#0B0E13] border-t border-[#1A1F2E] py-12 px-4" data-id="element-24">
        <div className="max-w-4xl mx-auto text-center" data-id="element-25">
          <p className="text-[#8B8578] text-sm mb-4" data-id="element-26">
            © {new Date().getFullYear()} Kit Anti-Pérdidas. Todos los derechos
            reservados.
          </p>
          <p className="text-[#8B8578]/60 text-xs max-w-2xl mx-auto mb-6" data-id="element-27">
            Este producto es material educativo y no constituye asesoría legal
            ni financiera. Para situaciones legales específicas, consulta
            siempre con un abogado de bienes raíces en tu estado.
          </p>
          <div className="flex items-center justify-center space-x-6" data-id="element-28">
            <button onClick={() => setShowTerms(true)} className="text-xs text-[#8B8578] hover:text-[#D4A843] transition-colors underline underline-offset-2" data-id="element-29">
              Términos y Condiciones
            </button>
            <span className="text-[#1A1F2E]" data-id="element-30">|</span>
            <button onClick={() => setShowPrivacy(true)} className="text-xs text-[#8B8578] hover:text-[#D4A843] transition-colors underline underline-offset-2" data-id="element-31">
              Política de Privacidad
            </button>
          </div>
        </div>
      </footer>

      {/* Terms Modal */}
      <LegalModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-32">
        <p className="text-[#F5F0E8] font-semibold" data-id="element-33">
          Última actualización: febrero 2026
        </p>

        <h3 className="text-[#D4A843] font-bold mt-4" data-id="element-34">
          1. Aceptación de los Términos
        </h3>
        <p data-id="element-35">
          Al adquirir el Kit Anti-Pérdidas ("el Producto"), aceptas estos
          Términos y Condiciones en su totalidad. Si no estás de acuerdo con
          alguno de estos términos, no realices la compra.
        </p>

        <h3 className="text-[#D4A843] font-bold mt-4" data-id="element-36">
          2. Descripción del Producto
        </h3>
        <p data-id="element-37">
          El Kit Anti-Pérdidas es un producto digital educativo en formato PDF
          que incluye mapas de riesgo, scripts, checklists y plantillas
          diseñadas para ayudar a compradores de casa en Estados Unidos a
          proteger su depósito (EMD) y gestionar contingencias durante el
          proceso de compra.
        </p>

        <h3 className="text-[#D4A843] font-bold mt-4" data-id="element-38">
          3. Naturaleza Educativa
        </h3>
        <p data-id="element-39">
          Este producto es exclusivamente material educativo e informativo.{' '}
          <span className="text-[#F5F0E8]" data-id="element-40">
            No constituye asesoría legal, financiera, fiscal ni inmobiliaria.
          </span>{' '}
          No reemplaza la consulta con un abogado de bienes raíces, un asesor
          financiero certificado ni ningún otro profesional licenciado en tu
          estado.
        </p>

        <h3 className="text-[#D4A843] font-bold mt-4" data-id="element-41">4. Entrega y Acceso</h3>
        <p data-id="element-42">
          El producto se entrega en formato digital (PDF) inmediatamente después
          de confirmar el pago. Recibirás un enlace de descarga por correo
          electrónico. Es tu responsabilidad proporcionar una dirección de
          correo válida.
        </p>

        <h3 className="text-[#D4A843] font-bold mt-4" data-id="element-43">
          5. Política de Reembolso
        </h3>
        <p data-id="element-44">
          Dado que el producto es digital y se entrega de forma inmediata, todas
          las ventas son finales. No se ofrecen reembolsos una vez descargado el
          material. Si tienes problemas técnicos con la descarga, contáctanos y
          te ayudaremos.
        </p>

        <h3 className="text-[#D4A843] font-bold mt-4" data-id="element-45">
          6. Propiedad Intelectual
        </h3>
        <p data-id="element-46">
          Todo el contenido del Kit Anti-Pérdidas está protegido por derechos de
          autor. Al comprarlo, obtienes una licencia personal e intransferible
          para uso individual. Queda prohibida la reproducción, distribución,
          reventa o compartición del material sin autorización expresa por
          escrito.
        </p>

        <h3 className="text-[#D4A843] font-bold mt-4" data-id="element-47">
          7. Limitación de Responsabilidad
        </h3>
        <p data-id="element-48">
          El uso del material es bajo tu propia responsabilidad. No nos hacemos
          responsables de decisiones financieras, legales o inmobiliarias
          tomadas con base en este contenido. Los resultados pueden variar según
          tu situación particular, el estado donde compres y los profesionales
          involucrados en tu transacción.
        </p>

        <h3 className="text-[#D4A843] font-bold mt-4" data-id="element-49">8. Modificaciones</h3>
        <p data-id="element-50">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Los cambios serán efectivos al publicarse en esta página.
        </p>

        <h3 className="text-[#D4A843] font-bold mt-4" data-id="element-51">9. Contacto</h3>
        <p data-id="element-52">
          Si tienes preguntas sobre estos términos, puedes escribirnos a nuestro
          correo de soporte indicado en tu confirmación de compra.
        </p>
      </LegalModal>

      {/* Privacy Modal */}
      <LegalModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-53">
        <p className="text-[#F5F0E8] font-semibold" data-id="element-54">
          Última actualización: febrero 2026
        </p>

        <h3 className="text-[#D4A843] font-bold mt-4" data-id="element-55">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-56">Al realizar tu compra, recopilamos la siguiente información:</p>
        <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-57">
          <li data-id="element-58">Nombre completo</li>
          <li data-id="element-59">Dirección de correo electrónico</li>
          <li data-id="element-60">
            Información de pago (procesada de forma segura por nuestro proveedor
            de pagos; no almacenamos datos de tarjeta)
          </li>
        </ul>

        <h3 className="text-[#D4A843] font-bold mt-4" data-id="element-61">
          2. Uso de la Información
        </h3>
        <p data-id="element-62">Utilizamos tu información para:</p>
        <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-63">
          <li data-id="element-64">Procesar y entregar tu compra</li>
          <li data-id="element-65">Enviarte el enlace de descarga del producto</li>
          <li data-id="element-66">Comunicarnos contigo sobre tu pedido o soporte técnico</li>
          <li data-id="element-67">Enviarte actualizaciones del producto (si aplica)</li>
        </ul>

        <h3 className="text-[#D4A843] font-bold mt-4" data-id="element-68">
          3. Protección de Datos
        </h3>
        <p data-id="element-69">
          Implementamos medidas de seguridad razonables para proteger tu
          información personal. Los pagos se procesan a través de plataformas
          seguras con encriptación SSL.{' '}
          <span className="text-[#F5F0E8]" data-id="element-70">
            Nunca almacenamos los datos completos de tu tarjeta de crédito o
            débito.
          </span>
        </p>

        <h3 className="text-[#D4A843] font-bold mt-4" data-id="element-71">
          4. Compartición de Datos
        </h3>
        <p data-id="element-72">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros, excepto cuando sea necesario para:
        </p>
        <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-73">
          <li data-id="element-74">Procesar tu pago (proveedor de pagos)</li>
          <li data-id="element-75">Entregar tu producto (servicio de email)</li>
          <li data-id="element-76">Cumplir con obligaciones legales</li>
        </ul>

        <h3 className="text-[#D4A843] font-bold mt-4" data-id="element-77">5. Cookies y Análisis</h3>
        <p data-id="element-78">
          Nuestro sitio puede utilizar cookies y herramientas de análisis para
          mejorar la experiencia del usuario y entender cómo se utiliza la
          página. Puedes desactivar las cookies en la configuración de tu
          navegador.
        </p>

        <h3 className="text-[#D4A843] font-bold mt-4" data-id="element-79">6. Tus Derechos</h3>
        <p data-id="element-80">Tienes derecho a:</p>
        <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-81">
          <li data-id="element-82">Solicitar acceso a los datos personales que tenemos sobre ti</li>
          <li data-id="element-83">Solicitar la corrección de datos inexactos</li>
          <li data-id="element-84">Solicitar la eliminación de tus datos personales</li>
          <li data-id="element-85">
            Darte de baja de comunicaciones de marketing en cualquier momento
          </li>
        </ul>

        <h3 className="text-[#D4A843] font-bold mt-4" data-id="element-86">7. Retención de Datos</h3>
        <p data-id="element-87">
          Conservamos tu información personal mientras sea necesario para
          cumplir con los fines descritos en esta política, a menos que la ley
          exija un período de retención más largo.
        </p>

        <h3 className="text-[#D4A843] font-bold mt-4" data-id="element-88">8. Menores de Edad</h3>
        <p data-id="element-89">
          Este producto está dirigido a personas mayores de 18 años. No
          recopilamos intencionalmente información de menores de edad.
        </p>

        <h3 className="text-[#D4A843] font-bold mt-4" data-id="element-90">
          9. Cambios a esta Política
        </h3>
        <p data-id="element-91">
          Podemos actualizar esta política periódicamente. Te notificaremos de
          cambios significativos a través del correo electrónico proporcionado
          en tu compra.
        </p>

        <h3 className="text-[#D4A843] font-bold mt-4" data-id="element-92">10. Contacto</h3>
        <p data-id="element-93">
          Para ejercer tus derechos o resolver dudas sobre privacidad,
          escríbenos al correo de soporte indicado en tu confirmación de compra.
        </p>
      </LegalModal>
    </>;
}